import ReportStep from '@billing/app/models/report-step.enum'
import { useBillingServiceStore } from '@billing/AppProvider'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { StorageReport } from '../components/storageReport/StorageReport'
import { StorageReportFilter } from '../components/storageReport/StorageReportFilter'
import { ReportNavigationButtonContainer } from './ReportNavigationButtonContainer'

export const StorageReportContainer = observer(() => {
  const { reportsUIStore, storageReportUIStore } = useBillingServiceStore()

  useEffect(() => {
    if (reportsUIStore.currentStep === ReportStep.Report) {
      storageReportUIStore.fetchStorageData()
    }
  }, [reportsUIStore.currentStep, storageReportUIStore])

  const finish = () => {
    storageReportUIStore.resetData()

    reportsUIStore.resetStepper()
  }

  return (
    <>
      {reportsUIStore.currentStep === ReportStep.Filter && <StorageReportFilter />}
      {reportsUIStore.currentStep === ReportStep.Report && <StorageReport />}
      <ReportNavigationButtonContainer
        disableNext={
          !storageReportUIStore.storageReportMode ||
          !storageReportUIStore.from ||
          !storageReportUIStore.to
        }
        downloadAction={() => storageReportUIStore.handleDownload?.()}
        finishAction={finish}
        disableDownload={!storageReportUIStore.handleDownload || storageReportUIStore.isLoading}
      />
    </>
  )
})
